import { css } from 'styled-components';
export const inViewMargin = '0px 0px -35% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const disableAnimationClass = '.equally-ai___toolbox-disable-buttons-animations';
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition: ${properties};
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
export function scrollTo(y) {
    const disabled = document.querySelector(disableAnimationClass);
    window.scrollTo({
        top: y,
        behavior: !disabled ? 'smooth' : 'auto',
    });
}
